"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunctionalApiError = void 0;
const axios_client_1 = require("@invivodf/axios-client");
const isFunctionalApiError = (error) => error instanceof axios_client_1.HttpError && error.status === 422;
exports.isFunctionalApiError = isFunctionalApiError;
